module.exports = __webpack_public_path__ + "img/searchColorIcon.075ea8e.svg";